import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface SimpleLeagueIconProps {
  color?: string
  size?: number
}

/**
 * Simple league icon with trophy design
 */
const SimpleLeagueIcon: React.FC<SimpleLeagueIconProps> = ({
  color = colors.PRIMARY,
  size = 72,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 72 72'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='72' height='72' rx='36' fill='#27303E' />
      <path
        d='M32.1334 37.9833L36.0001 35.05L39.8501 37.9833L38.3834 33.2333L42.2501 30.1667H37.5167L36.0001 25.4833L34.4834 30.1667H29.7501L33.6001 33.2333L32.1334 37.9833ZM49.3334 31.8333C49.3334 24.4667 43.3667 18.5 36.0001 18.5C28.6334 18.5 22.6667 24.4667 22.6667 31.8333C22.6667 35.2167 23.9334 38.2833 26.0001 40.6333V53.5L36.0001 50.1667L46.0001 53.5V40.6333C48.0667 38.2833 49.3334 35.2167 49.3334 31.8333ZM36.0001 21.8333C41.5167 21.8333 46.0001 26.3167 46.0001 31.8333C46.0001 37.35 41.5167 41.8333 36.0001 41.8333C30.4834 41.8333 26.0001 37.35 26.0001 31.8333C26.0001 26.3167 30.4834 21.8333 36.0001 21.8333ZM36.0001 46.8333L29.3334 48.5333V43.3667C31.3001 44.5 33.5667 45.1667 36.0001 45.1667C38.4334 45.1667 40.7001 44.5 42.6667 43.3667V48.5333L36.0001 46.8333Z'
        fill={color}
      />
    </svg>
  )
}

export default SimpleLeagueIcon
